// extracted by mini-css-extract-plugin
export default {"form":"login_form__ozup9","publicBg":"login_publicBg__fssOY"};